import React from 'react';
import ProductModal from 'components/ProductModal';
import { Text } from 'UI';

export const ReferenceProductModal = ({ referenceNumber }: { referenceNumber?: string }) => {
  if (!referenceNumber) {
    return null;
  }

  return (
    <ProductModal
      triggerComponent={
        <Text type="base" bold disableGutter hoverUnderLine cursor="pointer" data-cy="link-reference-number">
          {referenceNumber}
        </Text>
      }
      referenceNumber={referenceNumber}
      isVehicleCatalog
    />
  );
};
